module.exports = __webpack_public_path__ + "img/photo_1.b61fcc8c.jpg";